<span class="wep-ag-grid-no-rows-overlay__message" [ngStyle]="params.style()">
    {{params.message()}}
</span>